import axios from 'axios';
import store from './store';

const config = {
  api: process.env.VUE_APP_API_URL
};

const getClient = () => {
  return axios.create({
    baseURL: config.api,
    headers: {
      Authorization: `Bearer ${store.getters.jwt}`
    }
  });
};

export const postUrl = req => {
  return getClient().post(`/upload`, req);
};

export const postReport = report => {
  return getClient().post(`/report`, report);
};

export const fetchIsAuthenticated = () => {
  return getClient().get(`/authenticated`);
};

export const fetchThesisData = () => {
  return getClient().get(`/thesis`);
};

export const fetchThesisReports = uuid => {
  return getClient().get(`/reports/${uuid}`);
};

export const fetchThesesTeacher = teacher => {
  return getClient().get(`/theses/${teacher}`);
};

export const fetchThesesAll = () => {
  return getClient().get('/theses');
};

export const fetchUsers = () => {
  return getClient().get('/users');
};

export const modifyUser = (username, mode) => {
  return getClient().post('/modify', {
    username,
    mode
  });
};

export const renameUser = (username, firstName, lastName) => {
  return getClient().post('/rename', {
    username,
    firstName,
    lastName
  });
};

export const addUser = userData => {
  return getClient().post('/addUser', [userData]);
};

export const postLogin = (username, password) => {
  return getClient().post(`/auth`, {
    username,
    password
  });
};
